// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.membership-celebration {
  position: fixed;
  z-index: 200;
  inset: 0;
  display: grid;
  place-items: center;
  overflow: hidden;
  padding: calc(env(safe-area-inset-top, 0px) + 20px) 20px
    calc(env(safe-area-inset-bottom, 0px) + 20px);
  background: rgba(28, 27, 26, 0.56);
  backdrop-filter: blur(3px);
}

.membership-celebration__dialog {
  --celebration-color: var(--medal-gold);
  --celebration-soft: #fff8d8;
  position: relative;
  width: min(100%, 380px);
  max-height: 100%;
  overflow-y: auto;
  padding: 34px 28px 26px;
  border: 2px solid var(--celebration-color);
  border-radius: 24px;
  background:
    radial-gradient(circle at 50% 0%, var(--celebration-soft), transparent 44%),
    var(--palette-surface);
  box-shadow: 0 24px 70px rgba(28, 27, 26, 0.28);
  animation: membership-celebration-enter 420ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  text-align: center;
}

.membership-celebration__dialog--bronze {
  --celebration-color: var(--medal-bronze);
  --celebration-soft: #fff0e3;
}

.membership-celebration__dialog--silver {
  --celebration-color: var(--medal-silver);
  --celebration-soft: #eef2f5;
}

.membership-celebration__dialog--gold {
  --celebration-color: var(--medal-gold);
  --celebration-soft: #fff8d8;
}

.membership-celebration__close {
  position: absolute;
  top: 12px;
  right: 12px;
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border: 0;
  border-radius: 12px;
  color: var(--palette-text-muted);
  background: transparent;
  cursor: pointer;
}

.membership-celebration__close svg {
  width: 21px;
  height: 21px;
}

.membership-celebration__close:focus-visible,
.membership-celebration__done:focus-visible {
  outline: 3px solid var(--palette-secondary);
  outline-offset: 3px;
}

.membership-celebration__star {
  display: grid;
  width: 84px;
  height: 84px;
  margin: 0 auto 14px;
  place-items: center;
  border: 1px solid color-mix(in srgb, var(--celebration-color) 58%, white);
  border-radius: 999px;
  background: color-mix(in srgb, var(--celebration-color) 14%, white);
  box-shadow: 0 8px 24px color-mix(in srgb, var(--celebration-color) 18%, transparent);
}

.membership-celebration__star .tier-star--card {
  width: 54px;
  height: 54px;
  --tier-star-stroke-width: 1.25px;
}

.membership-celebration__eyebrow {
  color: var(--palette-primary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.membership-celebration h2 {
  margin: 6px 0 10px;
  padding: 0;
  font-family: var(--font-display);
  font-size: clamp(1.65rem, 7vw, 2rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.05;
}

.membership-celebration p {
  margin: 0;
  color: var(--palette-text-muted);
  font-size: 0.91rem;
  line-height: 1.55;
}

.membership-celebration ul {
  display: grid;
  gap: 10px;
  margin: 20px 0 22px;
  padding: 0;
  list-style: none;
  text-align: left;
}

.membership-celebration li {
  position: relative;
  padding-left: 25px;
  font-size: 0.86rem;
  line-height: 1.4;
}

.membership-celebration li::before {
  position: absolute;
  left: 2px;
  color: var(--palette-primary);
  content: "✓";
  font-weight: 800;
}

.membership-celebration__done {
  margin-top: 2px;
}

.membership-celebration__confetti {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.membership-celebration__confetti i {
  position: absolute;
  top: -9%;
  width: 9px;
  height: 15px;
  border-radius: 2px;
  background: var(--piece-color);
  animation-name: membership-confetti-fall;
  animation-timing-function: linear;
  animation-fill-mode: both;
}

.membership-celebration__confetti i:nth-child(4n + 1) {
  --piece-color: var(--palette-primary);
}

.membership-celebration__confetti i:nth-child(4n + 2) {
  --piece-color: var(--palette-secondary);
}

.membership-celebration__confetti i:nth-child(4n + 3) {
  --piece-color: var(--medal-gold);
}

.membership-celebration__confetti i:nth-child(4n) {
  --piece-color: #ffffff;
}

@keyframes membership-celebration-enter {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes membership-confetti-fall {
  from {
    opacity: 0;
    transform: translate3d(0, -8vh, 0) rotate(0deg);
  }
  12% {
    opacity: 1;
  }
  to {
    opacity: 0.9;
    transform: translate3d(24px, 112vh, 0) rotate(620deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .membership-celebration__dialog {
    animation: none;
  }

  .membership-celebration__confetti {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/membershipCelebration.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB;iDAC+C;EAC/C,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB;;0BAEwB;EACxB,8CAA8C;EAC9C,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yEAAyE;EACzE,oBAAoB;EACpB,mEAAmE;EACnE,oFAAoF;AACtF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,+CAA+C;EACjD;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".membership-celebration {\n  position: fixed;\n  z-index: 200;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  padding: calc(env(safe-area-inset-top, 0px) + 20px) 20px\n    calc(env(safe-area-inset-bottom, 0px) + 20px);\n  background: rgba(28, 27, 26, 0.56);\n  backdrop-filter: blur(3px);\n}\n\n.membership-celebration__dialog {\n  --celebration-color: var(--medal-gold);\n  --celebration-soft: #fff8d8;\n  position: relative;\n  width: min(100%, 380px);\n  max-height: 100%;\n  overflow-y: auto;\n  padding: 34px 28px 26px;\n  border: 2px solid var(--celebration-color);\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at 50% 0%, var(--celebration-soft), transparent 44%),\n    var(--palette-surface);\n  box-shadow: 0 24px 70px rgba(28, 27, 26, 0.28);\n  animation: membership-celebration-enter 420ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  text-align: center;\n}\n\n.membership-celebration__dialog--bronze {\n  --celebration-color: var(--medal-bronze);\n  --celebration-soft: #fff0e3;\n}\n\n.membership-celebration__dialog--silver {\n  --celebration-color: var(--medal-silver);\n  --celebration-soft: #eef2f5;\n}\n\n.membership-celebration__dialog--gold {\n  --celebration-color: var(--medal-gold);\n  --celebration-soft: #fff8d8;\n}\n\n.membership-celebration__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: grid;\n  width: 40px;\n  height: 40px;\n  place-items: center;\n  border: 0;\n  border-radius: 12px;\n  color: var(--palette-text-muted);\n  background: transparent;\n  cursor: pointer;\n}\n\n.membership-celebration__close svg {\n  width: 21px;\n  height: 21px;\n}\n\n.membership-celebration__close:focus-visible,\n.membership-celebration__done:focus-visible {\n  outline: 3px solid var(--palette-secondary);\n  outline-offset: 3px;\n}\n\n.membership-celebration__star {\n  display: grid;\n  width: 84px;\n  height: 84px;\n  margin: 0 auto 14px;\n  place-items: center;\n  border: 1px solid color-mix(in srgb, var(--celebration-color) 58%, white);\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--celebration-color) 14%, white);\n  box-shadow: 0 8px 24px color-mix(in srgb, var(--celebration-color) 18%, transparent);\n}\n\n.membership-celebration__star .tier-star--card {\n  width: 54px;\n  height: 54px;\n  --tier-star-stroke-width: 1.25px;\n}\n\n.membership-celebration__eyebrow {\n  color: var(--palette-primary);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.membership-celebration h2 {\n  margin: 6px 0 10px;\n  padding: 0;\n  font-family: var(--font-display);\n  font-size: clamp(1.65rem, 7vw, 2rem);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.05;\n}\n\n.membership-celebration p {\n  margin: 0;\n  color: var(--palette-text-muted);\n  font-size: 0.91rem;\n  line-height: 1.55;\n}\n\n.membership-celebration ul {\n  display: grid;\n  gap: 10px;\n  margin: 20px 0 22px;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n}\n\n.membership-celebration li {\n  position: relative;\n  padding-left: 25px;\n  font-size: 0.86rem;\n  line-height: 1.4;\n}\n\n.membership-celebration li::before {\n  position: absolute;\n  left: 2px;\n  color: var(--palette-primary);\n  content: \"✓\";\n  font-weight: 800;\n}\n\n.membership-celebration__done {\n  margin-top: 2px;\n}\n\n.membership-celebration__confetti {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.membership-celebration__confetti i {\n  position: absolute;\n  top: -9%;\n  width: 9px;\n  height: 15px;\n  border-radius: 2px;\n  background: var(--piece-color);\n  animation-name: membership-confetti-fall;\n  animation-timing-function: linear;\n  animation-fill-mode: both;\n}\n\n.membership-celebration__confetti i:nth-child(4n + 1) {\n  --piece-color: var(--palette-primary);\n}\n\n.membership-celebration__confetti i:nth-child(4n + 2) {\n  --piece-color: var(--palette-secondary);\n}\n\n.membership-celebration__confetti i:nth-child(4n + 3) {\n  --piece-color: var(--medal-gold);\n}\n\n.membership-celebration__confetti i:nth-child(4n) {\n  --piece-color: #ffffff;\n}\n\n@keyframes membership-celebration-enter {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes membership-confetti-fall {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -8vh, 0) rotate(0deg);\n  }\n  12% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.9;\n    transform: translate3d(24px, 112vh, 0) rotate(620deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .membership-celebration__dialog {\n    animation: none;\n  }\n\n  .membership-celebration__confetti {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
